import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const interpretSituation = (text, situationHint) =>
  api.post("/interpret", { text, situation_hint: situationHint }).then((r) => r.data);

export const getLifeCard = (uid) => api.get(`/lifecard/${uid}`).then((r) => r.data);
export const saveLifeCard = (card) => api.post("/lifecard", card).then((r) => r.data);

export const listTrust = (uid) => api.get(`/trust/${uid}`).then((r) => r.data);
export const addTrust = (uid, body) => api.post(`/trust/${uid}`, body).then((r) => r.data);
export const removeTrust = (uid, cid) => api.delete(`/trust/${uid}/${cid}`).then((r) => r.data);

export const createStatus = (body) => api.post("/status", body).then((r) => r.data);
export const getStatus = (slug) => api.get(`/status/${slug}`).then((r) => r.data);
export const patchStatus = (slug, state) => api.patch(`/status/${slug}`, { state }).then((r) => r.data);

export const getSafetyPoints = (lat, lng) =>
  api.get("/safety-points", { params: { lat, lng } }).then((r) => r.data);
